
import { DebtManagement as NewDebtManagement } from './debt/DebtManagement';

export const DebtManagement = NewDebtManagement;
